import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {FileService} from "../../../services/file/file.service";
import {ContentTypes} from "../../../services/db/config/content-types";
import {DatabaseService} from "../../../services/db/database.service";
import {BasicResource} from "../../../models/ressources/basic-resource";
import {MatDialogRef} from "@angular/material/dialog";
import {DbKeys} from "../../../services/db/config/db-config";
import {MatSnackBar} from "@angular/material/snack-bar";

@Component({
  selector: 'app-create-custom-resource',
  templateUrl: './create-custom-resource.component.html',
  styleUrls: ['./create-custom-resource.component.scss']
})
export class CreateCustomResourceComponent implements OnInit {
  protected resourceForm: FormGroup;
  protected contentType: ContentTypes
  protected canSubmit: boolean;

  constructor(
    private readonly fb: FormBuilder,
    private readonly fileService: FileService,
    private readonly db: DatabaseService,
    private readonly snackbar: MatSnackBar,
    public dialogRef: MatDialogRef<CreateCustomResourceComponent>,
  ) {
    //accept pdf and images
    this.contentType = ContentTypes.pdf;
    this.canSubmit = true;
  }

  ngOnInit(): void {
    this.resourceForm = this.fb.group({
      name: ['', Validators.required],
      file: ['', Validators.required],
    });
  }

  get name() {
    return this.resourceForm.get('name') as FormControl;
  }

  get file() {
    return this.resourceForm.get('file') as FormControl;
  }

  async onSubmit(formData: any) {
    this.canSubmit = false;

    if(this.resourceForm.valid) {
      const name = formData.name;
      const file = formData.file;

      const path = `${DbKeys.customResources}`;

      try {
        const uploadResult = await this.fileService.uploadFile(file, path, this.contentType);
        const downloadUrl = await uploadResult.ref.getDownloadURL();
        const resource = new BasicResource('', downloadUrl, name);

        await this.db.addData({name: resource.getName(), url: resource.getResourceUrl()}, DbKeys.customResources);
      } catch (e) {
        this.snackbar.open(`"Erreur lors de l'ajout : "${e}"`)
      } finally {
        this.dialogRef.close();
      }
    }
  }

  onFileChange({ target }: Event) {
    const files = (target as HTMLInputElement).files;
    const file = files?.[0];

    file && this.resourceForm.patchValue({ file });
  }
}
